import axios from 'axios'
import { getCookie } from '@/pkg/cookie'

let toolsClient
const token = getCookie('resource')

if (process.env.NODE_ENV === 'development') {
  toolsClient = axios.create({
    baseURL: process.env.VUE_APP_APIGO_URL,
    headers: { Authorization: `Bearer ${token}` },
  })

} else {
  toolsClient = axios.create({
    baseURL: process.env.VUE_APP_APIGO_URL,
    withCredentials: true,
  })
}

export function getToolsClient() {
  return toolsClient
}

